import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { Helmet } from "react-helmet";

const API_PDF_URL = process.env.REACT_APP_API_PDF_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;

const DisclosureUR30OfLord = () => {
    const pageid = 14; // <-- static pageid
  const [disclosureItems, setDisclosureItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDisclosures = async () => {
      try {
        const response = await fetch(`${BASE_URL}?pageid=${pageid}`); // replace pageid with correct
        if (!response.ok) throw new Error(`HTTP error! ${response.status}`);
        const result = await response.json();

        if (!result.success || !Array.isArray(result.data)) {
          setDisclosureItems([]);
          return;
        }

        const items = result.data.map((item) => ({
          label: item.pdf_name,
          file: item.upload_file_path,
        }));

        setDisclosureItems(items);
      } catch (error) {
        console.error("Fetch failed:", error);
        setDisclosureItems([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDisclosures();
  }, []);

  return (
    <>
      <Helmet>
        <title>Disclosure U.R.30 Of Lodr | Nandan Denim Ltd.</title>
      </Helmet>
      <Header />

      {/* Hero Section */}
      <div className="relative bg-[#193267] p-32 w-full">
        <h1 className="text-white text-3xl sm:text-5xl md:text-7xl font-bold text-left">
          Disclosure U.R. 30 of LODR
        </h1>
      </div>

      {/* PDF List Section */}
      <div className="py-12 px-4 font-signika max-w-7xl mx-auto">
        {loading ? (
          <p>Loading disclosures...</p>
        ) : disclosureItems.length === 0 ? (
          <p>No disclosures found.</p>
        ) : (
          <ul className="list-disc pl-6 space-y-4 text-[#0b3a6a]">
            {disclosureItems.map((item, index) => (
              <li key={index}>
                <a
                  href={`${API_PDF_URL}/${item.file}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>

      <Footer />
    </>
  );
};

export default DisclosureUR30OfLord;
